module.exports = __webpack_public_path__ + "static/key-horizon-bb1d2e2f926273972071f322ca7d28ae.webp";